/** Created by azhou on 2019/3/14.*/
<template>
    <div>
      <public-title>{{queryCon.cn}}
        <span class="text-link ml-auto h6" slot="right" @click="$router.back()">返回列表</span>
      </public-title>
      <div class="bg-white p-3">
        <p v-if="StoreChartDetail.total<=0">当前没有数据</p>
        <div v-else>
          <ul class="list-head"><li class="w-50" v-for="item in titleArr" :key="item">{{item}}</li></ul>
          <ul class="list-item" v-for="Itemize in StoreChartDetail.lists" :key="Itemize.id">
            <li class="w-50 list-item-col breakword">{{Itemize.order_nos}}</li>
            <li class="w-50 list-item-col">{{Itemize.company}}</li>
            <li class="w-50 list-item-col" v-if="storeInfo.type == 3">{{Itemize.title}}</li>
            <li class="w-50 list-item-col">{{Itemize.order_send_time | formatTimestamp(1)}}</li>
            <li class="w-50 list-item-col" v-show="queryCon.type==='income'">&yen;{{Itemize.money/100 | formatMoney}}</li>
          </ul>
          <el-pagination background layout="prev, pager, next" class="mt-4"
                        :total="StoreChartDetail.total" :current-page="Number(queryCon.page)"
                        @current-change="$GFUN.pageChange"/>
      </div>
    </div>
    </div>
</template>

<script>
  import { mapGetters,mapMutations, mapActions,mapState } from 'vuex'

  export default {
    name: 'ChartDetail',
    computed: {
      ...mapState(['StoreChartDetail']),
      ...mapGetters(['storeInfo']),
      queryCon() { return this.$route.query },
      titleArr() {
        let arr = ['订单号','发单人','订单发布时间','金额'];
        let arrnum = ['订单号','发单人','订单发布时间']
        switch (this.queryCon.type) {
          case 'income': if(this.storeInfo.type == 3) arr.splice(2, 0, '团号'); return arr;
          default: if(this.storeInfo.type == 3) arrnum.splice(2, 0, '团号'); return arrnum;
        }
      }
    },
    watch:{
      queryCon() { this.getList(); },
    },
    mounted() {
      this.UPDATECURRENTSTORE({storeId:this.queryCon.store});
      this.getList();
    },
    destroyed() {
      this.UPDATECURRENTSTORE({storeId:''})
    },
    methods:{
      ...mapMutations(['UPDATECURRENTSTORE']),
      ...mapActions(['getStoreChartDetail']),
      getList() {
        this.getStoreChartDetail({
          start_time: this.queryCon.startdate,
          end_time: this.queryCon.enddate,
          details_type: this.queryCon.type,
          store_id: this.queryCon.store || this.storeInfo.storeId,
        });
      }
    }
  }
</script>
